import {Moment} from 'moment-timezone'

import {DatetimeValue} from '../types'

const MINUTES_PER_HOUR = 60

interface GetCostsMWhAndTonsParams {
  prices: DatetimeValue<Moment>[]
  powerConsumption: number
  throughput: number | null
}

/**
 * Calculate cumulated costs, consumed MWh and produced tons
 * for a given datetime - value range
 * @param prices should be an inclusive array
 */
export const getCostsMWhAndTons = ({
  prices,
  powerConsumption,
  throughput
}: GetCostsMWhAndTonsParams) => {
  let cumulatedCosts = 0
  let cumulatedMWh = 0
  let cumulatedTons = 0

  prices.forEach(({datetime, value: priceValue}, index) => {
    const nextPrice: DatetimeValue<Moment> | undefined = prices[index + 1]
    // duration in hours
    const duration =
      nextPrice !== undefined
        ? nextPrice.datetime.diff(datetime, 'minutes', true) / MINUTES_PER_HOUR
        : 0

    cumulatedCosts += priceValue * powerConsumption * duration
    cumulatedMWh += powerConsumption * duration
    cumulatedTons += (throughput ?? 0) * duration
  })

  return {cumulatedCosts, cumulatedMWh, cumulatedTons}
}
